import {CreateSchemaState} from "./CreateSchemaContext";

export enum ActionType {
  TOGGLE_REQUEST_IN_PROGRESS,
  UPLOAD_ONTOLOGIES,
  ONTOLOGY_UPLOAD_PROGRESS,
  ONTOLOGY_FILES_UPLOADED,
  DELETE_ONTOLOGY,
  ONTOLOGY_UPLOAD_FAIL,
  DELETE_ONTOLOGY_FAIL,
  GENERATE_SCHEMA,
  GENERATE_SCHEMA_COMPLETE,
  GENERATE_SCHEMA_FAIL,
  SAVE_SCHEMA,
  UPDATE_SCHEMA,
  UPDATE_SCHEMA_FAIL,
  CHANGE_SCHEMA,
  SAVE_SCHEMA_FAIL,
  ACTIVATE_SCHEMA_FAIL,
  WIZARD_ERROR,
  REMOVE_ERROR,
  ADD_ERROR,
  SET_SCHEMA_ID,
  REMOVE_GENERATION_WARNINGS
}

type Action = {
  type: ActionType;
  payload: any
}

export default (state: CreateSchemaState, action: Action) => {
  switch (action.type) {
    case ActionType.TOGGLE_REQUEST_IN_PROGRESS:
      return {
        ...state,
        isRequestRunning: action.payload.isRequestRunning
      };
    case ActionType.UPLOAD_ONTOLOGIES:
      return {
        ...state,
        files: action.payload.files
      };
    case ActionType.ONTOLOGY_UPLOAD_PROGRESS:
      return {
        ...state,
        progress: action.payload.progress,
        uploading: action.payload.uploading
      };
    case ActionType.ONTOLOGY_FILES_UPLOADED:
      const files = [...state.files];
      action.payload.files.forEach((file: any) => {
        const foundIndex = files.findIndex((existingFile: any) => existingFile.originalname === file.originalname);
        foundIndex === -1 ? files.push(file) : files.splice(foundIndex, 1, file);
      });
      return {
        ...state,
        files,
        uploading: action.payload.uploading
      };
    case ActionType.DELETE_ONTOLOGY:
      return {
        ...state,
        files: action.payload.files,
        uploading: action.payload.uploading
      };
    case ActionType.ONTOLOGY_UPLOAD_FAIL:
      return {
        ...state,
        uploading: action.payload.uploading
      };
    case ActionType.DELETE_ONTOLOGY_FAIL:
      return {
        ...state
      };
    case ActionType.GENERATE_SCHEMA:
      return {
        ...state,
        schema: action.payload.schema,
        schemaId: action.payload.schemaId,
        generationWarnings: action.payload.generationWarnings,
        isRequestRunning: action.payload.isRequestRunning
      };
    case ActionType.GENERATE_SCHEMA_COMPLETE:
      return {
        ...state,
        schema: action.payload.schema,
        schemaId: action.payload.schemaId,
        isRequestRunning: action.payload.isRequestRunning
      };
    case ActionType.SAVE_SCHEMA:
      return {
        ...state,
        schemaId: action.payload.schemaId,
        schema: action.payload.schema,
        permissions: action.payload.permissions
      };
    case ActionType.CHANGE_SCHEMA:
    case ActionType.UPDATE_SCHEMA:
      return {
        ...state,
        schema: action.payload.schema
      };
    case ActionType.WIZARD_ERROR:
      return {
        ...state,
        error: action.payload
      };
    case ActionType.REMOVE_ERROR:
      return {
        ...state,
        error: null
      };
    case ActionType.REMOVE_GENERATION_WARNINGS:
      return {
        ...state,
        generationWarnings: action.payload.generationWarnings
      };
    case ActionType.SET_SCHEMA_ID:
      return {
        ...state,
        schemaId: action.payload.schemaId
      };
    case ActionType.GENERATE_SCHEMA_FAIL:
    case ActionType.ACTIVATE_SCHEMA_FAIL:
    case ActionType.SAVE_SCHEMA_FAIL:
    case ActionType.ADD_ERROR:
      return {
        ...state,
        error: action.payload.error
      };
    default:
      return state;
  }
}
